export enum OnboardingV2DealSizeUnavailableReason {
  NoOrders = "no_orders",
}
